import { render, staticRenderFns } from "./InstallationPicker.vue?vue&type=template&id=995bc0d4&"
import script from "./InstallationPicker.vue?vue&type=script&lang=ts&"
export * from "./InstallationPicker.vue?vue&type=script&lang=ts&"
import style0 from "./InstallationPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports